import type { ReactElement } from "react";

import type { LinkProps } from "react-router-dom";

import { styled } from "simplydo/react/styled";

import type { MenuItemProps } from "./Menu.types";
import { RenderMenuItem } from "./MenuItem";

export type MenuItemLinkProps = MenuItemProps &
  Omit<LinkProps, "children" | "className" | "style">;

const MenuItemLinkComponent = (props: MenuItemLinkProps): ReactElement => (
  <RenderMenuItem {...props} asLink />
);

export const MenuItemLink = styled(MenuItemLinkComponent)``;
